import { useCallback, useEffect, useRef } from 'react'

import { CURSOR_TYPES } from '@/pages/benefits/events/constants'
import {
  addScrollEventListeners,
  calculateScrollPosition,
  removeScrollEventListeners,
  setCursor
} from '@/pages/benefits/events/helpers'

const useDragScroll = () => {
  const isDragging = useRef(false)
  const startPosition = useRef({ x: 0, scrollLeft: 0 })
  const cleanup = useRef(() => {})

  const handleMouseDown = useCallback((e) => {
    const container = e.currentTarget

    isDragging.current = true
    startPosition.current = {
      x: e.pageX - container.offsetLeft,
      scrollLeft: container.scrollLeft
    }
    setCursor(container, CURSOR_TYPES.GRABBING)

    const handleMouseMove = (moveEvent) => {
      if (!isDragging.current) return

      const currentX = moveEvent.pageX - container.offsetLeft

      container.scrollLeft = calculateScrollPosition(
        currentX,
        startPosition.current.x,
        startPosition.current.scrollLeft
      )
    }

    const handleMouseUp = () => {
      isDragging.current = false
      setCursor(container, CURSOR_TYPES.GRAB)
      removeScrollEventListeners(handleMouseMove, handleMouseUp)
      cleanup.current = () => {} // Reset cleanup
    }

    addScrollEventListeners(handleMouseMove, handleMouseUp)

    cleanup.current = () => {
      isDragging.current = false
      removeScrollEventListeners(handleMouseMove, handleMouseUp)
    }
  }, [])

  useEffect(() => {
    return () => {
      cleanup.current()
    }
  }, [])

  return { handleMouseDown }
}

export default useDragScroll
